import * as signalR from '@microsoft/signalr'
import Configuration from '@/configuration'
import { EventBus } from '@/common/event-bus'

export default {
  install: (app) => {
    const connection = new signalR.HubConnectionBuilder().withUrl(Configuration.value('hub')).build()

    connection.on('UserUpdated', (mocID, users) => {
      EventBus.emit('user-updated', { mocID, users })
    })

    const mocHub = {}

    mocHub.mocOpened = (mocId, user) => {
      return startedPromise.then(() => connection.invoke('JoinMocGroup', mocId, user)).catch(console.error)
    }
    mocHub.mocClosed = (mocId, user) => {
      return startedPromise.then(() => connection.invoke('LeaveMocGroup', mocId, user)).catch(console.error)
    }
    app.config.globalProperties.$mocHub = mocHub

    let startedPromise = null
    function start(backoffTime = 1) {
      if (backoffTime > 128) {
        console.error('backoff timer hit')
        return
      } else {
        startedPromise = connection.start({ withCredentials: true }).catch((err) => {
          return new Promise((resolve, reject) => {
            console.error('Failed to connect with hub', err)
            setTimeout(() => {
              return start(backoffTime * 2)
            }, backoffTime * 1000)
          })
        })
        return startedPromise
      }
    }
    connection.onclose(() => start())

    start()
  }
}
